// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4ae3bca9","239":"f7d67107","455":"31a8dc25"}[chunkId] + ".chunk.js";
};